var _filter, _filter2, _rect, _pattern, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _text, _text2, _g8, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchitectureFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "darkBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c0c1d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a5f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f2744"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4c1d95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2e1065"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardGrad3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#065f46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#064e3b"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrowGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cardShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#000",
    floodOpacity: 0.3
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "iconGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 400,
    fill: "url(#darkBg)"
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    patternUnits: "userSpaceOnUse",
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 1,
    fill: "#3b82f6",
    opacity: 0.15
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 400,
    fill: "url(#dots)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 120)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 160,
    rx: 12,
    fill: "url(#cardGrad1)",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 45)",
    filter: "url(#iconGlow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -15,
    rx: 25,
    ry: 8,
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25,-15 L-25,15 Q-25,23 0,23 Q25,23 25,15 L25,-15",
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 15,
    rx: 25,
    ry: 8,
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 105)",
    filter: "url(#iconGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-15,15 L0,-20 L5,0 L15,15 L0,25 Z",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10,5 L15,15",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 150,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 500
  }, "DATA SOURCES"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(230, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,0",
    stroke: "url(#arrowGrad)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "20;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55,-6 70,0 55,6",
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#3b82f6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(305, 145)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 110,
    rx: 12,
    fill: "#1f2937",
    stroke: "#6366f1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 45)",
    filter: "url(#iconGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: 0,
    r: 10,
    fill: "none",
    stroke: "#818cf8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 0,
    r: 10,
    fill: "none",
    stroke: "#818cf8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8,
    y1: 0,
    x2: 8,
    y2: 0,
    stroke: "#a5b4fc",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "monospace",
    fontSize: 12,
    fontWeight: "bold"
  }, "MCP"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 100,
    textAnchor: "middle",
    fill: "#6b7280",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Protocol"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(415, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,0",
    stroke: "url(#arrowGrad)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "20;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55,-6 70,0 55,6",
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#3b82f6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(490, 100)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 200,
    rx: 12,
    fill: "url(#cardGrad2)",
    stroke: "#a855f7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 60)",
    filter: "url(#iconGlow)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 35,
    ry: 28,
    fill: "none",
    stroke: "#c084fc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -12,
    cy: -8,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: -10,
    r: 4,
    fill: "#c084fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 8,
    r: 6,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -18,
    cy: 10,
    r: 3,
    fill: "#c084fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 4,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: -8,
    x2: 12,
    y2: -10,
    stroke: "#e9d5ff",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: -8,
    x2: 0,
    y2: 8,
    stroke: "#e9d5ff",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: -10,
    x2: 0,
    y2: 8,
    stroke: "#e9d5ff",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: -18,
    y2: 10,
    stroke: "#e9d5ff",
    strokeWidth: 1,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 18,
    y2: 8,
    stroke: "#e9d5ff",
    strokeWidth: 1,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 115,
    textAnchor: "middle",
    fill: "#e9d5ff",
    fontFamily: "system-ui",
    fontSize: 14,
    fontWeight: "bold"
  }, "LLM"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 135,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "system-ui",
    fontSize: 10
  }, "Processing"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 155)",
    fill: "#c4b5fd",
    fontFamily: "system-ui",
    fontSize: 9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -3,
    r: 2,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 0
  }, "Context Analysis"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 13,
    r: 2,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 16
  }, "Data Synthesis"), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 29,
    r: 2,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 8,
    y: 32
  }, "Insight Generation")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(640, 200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L60,0",
    stroke: "url(#arrowGrad)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "20;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55,-6 70,0 55,6",
    fill: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#3b82f6"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(715, 120)",
    filter: "url(#cardShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 140,
    height: 160,
    rx: 12,
    fill: "url(#cardGrad3)",
    stroke: "#10b981",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70, 50)",
    filter: "url(#iconGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -25,
    width: 56,
    height: 45,
    rx: 4,
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: 5,
    width: 8,
    height: 10,
    fill: "#10b981",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -5,
    width: 8,
    height: 20,
    fill: "#34d399",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: -12,
    width: 8,
    height: 27,
    fill: "#10b981",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 0,
    width: 8,
    height: 15,
    fill: "#34d399",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22,
    y1: -18,
    x2: 22,
    y2: -18,
    stroke: "#6ee7b7",
    strokeWidth: 2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22,
    y1: -12,
    x2: 10,
    y2: -12,
    stroke: "#6ee7b7",
    strokeWidth: 1.5,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 100,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui",
    fontSize: 12,
    fontWeight: "bold"
  }, "Generative UI"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 120,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "system-ui",
    fontSize: 10
  }, "thesys.dev"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 145,
    textAnchor: "middle",
    fill: "#a7f3d0",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Human-Readable"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 155,
    textAnchor: "middle",
    fill: "#a7f3d0",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Analytics Reports"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 45,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "system-ui",
    fontSize: 22,
    fontWeight: "bold"
  }, "System Architecture Flow")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 70,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 12
  }, "Data Sources \u2192 LLM Processing \u2192 Actionable Insights")), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#1e293b",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 105,
    r: 12,
    fill: "#3b82f6"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 109,
    textAnchor: "middle",
    fill: "white"
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 130,
    r: 12,
    fill: "#6366f1"
  }), /*#__PURE__*/React.createElement("text", {
    x: 335,
    y: 134,
    textAnchor: "middle",
    fill: "white"
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 85,
    r: 12,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 89,
    textAnchor: "middle",
    fill: "white"
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 755,
    cy: 105,
    r: 12,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("text", {
    x: 755,
    y: 109,
    textAnchor: "middle",
    fill: "white"
  }, "4"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 340)",
    fill: "#475569",
    fontFamily: "system-ui",
    fontSize: 10
  }, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 0,
    textAnchor: "middle"
  }, "PostgreSQL + Firebase"), /*#__PURE__*/React.createElement("text", {
    x: 355,
    y: 0,
    textAnchor: "middle"
  }, "Model Context Protocol"), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 0,
    textAnchor: "middle"
  }, "Large Language Model"), /*#__PURE__*/React.createElement("text", {
    x: 785,
    y: 0,
    textAnchor: "middle"
  }, "Visual Analytics"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectureFlow);
export default __webpack_public_path__ + "static/media/architecture-flow.843b5f2e66316fff356b07ec5525c4e8.svg";
export { ForwardRef as ReactComponent };